export const VisaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="#1434CB" />
    <path
      d="M16.2985 5L12.8755 14.2326L12.5009 12.3598L11.2814 6.14092C11.0811 5.27866 10.4627 5.03479 9.69619 5H4.06108L4 5.27004C5.37617 5.6185 6.60434 6.12369 7.67556 6.75942L10.7938 18.5179H14.4954L20 5.00011L16.2985 5Z"
      fill="white"
    />
  </svg>
);
